(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  let cfg = {};
  try { cfg = JSON.parse($('#cp-shop-config').textContent); } catch (e) {}
  const root = cfg.root || '/';
  const money = c => new Intl.NumberFormat('en-GB', { style: 'currency', currency: cfg.currency || 'GBP', minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(c / 100);
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const toast = $('.toast');
  let toastTimer;
  function notice(message) { if (!toast) return; toast.textContent = message; toast.classList.add('show'); clearTimeout(toastTimer); toastTimer = setTimeout(() => toast.classList.remove('show'), 4000); }
  async function request(path, body) {
    const r = await fetch(root + path, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...(body ? { body: JSON.stringify(body) } : {}) });
    const d = await r.json();
    if (!r.ok) throw new Error(d.description || d.message || 'Please try again.');
    return d;
  }
  const setCount = n => $$('.bag-count').forEach(e => { e.textContent = n; });

  // Mobile menu
  const menu = $('.menu-button'), nav = $('#main-nav');
  if (menu && nav) {
    menu.addEventListener('click', () => { const open = nav.classList.toggle('open'); menu.setAttribute('aria-expanded', open); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && nav.classList.contains('open')) { nav.classList.remove('open'); menu.setAttribute('aria-expanded', 'false'); menu.focus(); } });
  }

  // Bag dialog
  const bagDialog = $('#bag-dialog');
  async function renderBag() {
    const bag = await request('cart.js');
    setCount(bag.item_count);
    if (!bagDialog) return bag;
    $('.bag-items', bagDialog).innerHTML = bag.items.length
      ? bag.items.map(p => `<div class="bag-row">${p.image ? `<img src="${esc(p.image)}" alt="" width="60">` : ''}<div><a href="${esc(p.url)}">${esc(p.product_title.replace(' Contour Print', ''))}</a><small>${esc(((t => t[0].replace('x', ' × ') + (t[2] ? ' · ' + t[2] : ''))((p.variant_title || '').split(' / '))))} · Quantity ${p.quantity}</small><button type="button" data-remove="${esc(p.key)}">Remove</button></div><span>${money(p.final_line_price)}</span></div>`).join('')
      : '<p>Your bag is empty. Find the hill that stays with you.</p>';
    $('.bag-total', bagDialog).textContent = bag.items.length ? 'Subtotal ' + money(bag.total_price) : '';
    $('.checkout-link', bagDialog).hidden = !bag.items.length;
    $$('[data-remove]', bagDialog).forEach(b => b.addEventListener('click', async () => {
      b.disabled = true;
      try { await request('cart/change.js', { id: b.dataset.remove, quantity: 0 }); await renderBag(); } catch (e) { b.disabled = false; notice(e.message); }
    }));
    return bag;
  }
  if (bagDialog && typeof bagDialog.showModal === 'function') {
    $$('[data-bag]').forEach(b => b.addEventListener('click', async e => {
      e.preventDefault();
      bagDialog.showModal();
      try { await renderBag(); } catch (err) { $('.bag-items', bagDialog).textContent = err.message; }
    }));
    $$('.dialog-close,.continue-shopping', bagDialog).forEach(b => b.addEventListener('click', () => bagDialog.close()));
    bagDialog.addEventListener('click', e => {
      if (e.target !== bagDialog) return;
      const r = bagDialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) bagDialog.close();
    });
  }

  // Product page
  const form = $('[data-product-form]');
  if (form) {
    const price = $('[data-pdp-price]'), add = $('[data-pdp-add]', form), label = $('[data-pdp-add-label]', form), error = $('[data-pdp-error]', form);
    $$('input[name="id"]', form).forEach(input => input.addEventListener('change', () => {
      if (price) price.textContent = money(+input.dataset.price);
      try { const u = new URL(location.href); u.searchParams.set('variant', input.value); history.replaceState(null, '', u); } catch (e) {}
    }));
    form.addEventListener('submit', async e => {
      if (!bagDialog || typeof bagDialog.showModal !== 'function') return;
      e.preventDefault();
      const chosen = $('input[name="id"]:checked', form) || $('input[name="id"]', form);
      if (!chosen || add.disabled) return;
      const text = label.textContent;
      add.disabled = true; label.textContent = 'Adding…'; if (error) error.hidden = true;
      try {
        await request('cart/add.js', { items: [{ id: +chosen.value, quantity: 1 }] });
        await renderBag();
        bagDialog.showModal();
      } catch (err) {
        if (error) { error.textContent = err.message; error.hidden = false; } else notice(err.message);
      } finally { add.disabled = false; label.textContent = text; }
    });
  }

  // Collection finder
  const grid = $('[data-hill-grid]'), tools = $('[data-shop-tools]');
  if (grid && tools) {
    const cards = $$('[data-hill-card]', grid), count = $('[data-hill-count]'), empty = $('[data-hill-empty]'), search = $('[data-hill-search]'), sort = $('[data-hill-sort]');
    cards.forEach((c, i) => { c.dataset.order = i; });
    tools.hidden = false;
    let country = '';
    function apply() {
      const q = (search?.value || '').trim().toLowerCase();
      let shown = 0;
      cards.forEach(c => {
        const ok = (!country || c.dataset.country === country) && (!q || c.dataset.search.includes(q));
        c.hidden = !ok; if (ok) shown++;
      });
      if (count) count.textContent = shown ? shown + (shown === 1 ? ' hill' : ' hills') + ' · three sizes each' : 'No hills match';
      if (empty) empty.hidden = shown > 0;
    }
    $$('[data-filter]', tools).forEach(b => b.addEventListener('click', () => {
      country = b.dataset.filter;
      $$('[data-filter]', tools).forEach(x => x.setAttribute('aria-pressed', x === b));
      apply();
    }));
    search?.addEventListener('input', apply);
    sort?.addEventListener('change', () => {
      const by = sort.value;
      const sorted = [...cards].sort((a, b) => by === 'name' ? a.dataset.name.localeCompare(b.dataset.name) : by === 'height' ? (+b.dataset.height || 0) - (+a.dataset.height || 0) : a.dataset.order - b.dataset.order);
      sorted.forEach(c => grid.appendChild(c));
    });
    $('[data-hill-reset]')?.addEventListener('click', () => {
      country = ''; if (search) search.value = '';
      $$('[data-filter]', tools).forEach(x => x.setAttribute('aria-pressed', x.dataset.filter === ''));
      apply();
    });
  }

  // Cart page
  function bindCart() {
    const section = $('[data-cart-section]');
    if (!section) return;
    const id = section.dataset.cartSection;
    async function change(key, quantity) {
      section.classList.add('is-busy');
      try {
        const bag = await request('cart/change.js', { id: key, quantity });
        setCount(bag.item_count);
        const r = await fetch(location.pathname + '?section_id=' + encodeURIComponent(id));
        if (!r.ok) throw new Error('refresh');
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const fresh = doc.querySelector('[data-cart-section]');
        if (!fresh) throw new Error('refresh');
        section.replaceWith(fresh);
        bindCart();
      } catch (e) {
        if (e.message === 'refresh') location.reload();
        else { section.classList.remove('is-busy'); notice(e.message); }
      }
    }
    $$('[data-cart-row]', section).forEach(row => {
      const key = row.dataset.key, input = $('[data-qty-input]', row);
      $$('[data-qty-step]', row).forEach(b => b.addEventListener('click', () => change(key, Math.max(0, (+input.value || 0) + +b.dataset.qtyStep))));
      input.addEventListener('change', () => change(key, Math.max(0, Math.floor(+input.value || 0))));
      input.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
      $('[data-cart-remove]', row)?.addEventListener('click', e => { e.preventDefault(); change(key, 0); });
    });
  }
  bindCart();
})();
(()=>{const ck=document.querySelector('[data-cookie-settings]');if(!ck)return;const ok=()=>window.privacyBanner&&typeof window.privacyBanner.showPreferences==='function';const reveal=()=>{if(ok())ck.hidden=false};reveal();addEventListener('load',()=>{reveal();setTimeout(reveal,2000)});ck.addEventListener('click',e=>{e.preventDefault();if(ok())window.privacyBanner.showPreferences()})})();
